import { api } from "../api.slice";
import { GetCardToCardsRequest, GetPaymentTokenRequest } from "@/types/payment";
import {AddCardToCardResponse, CardToCard} from "@/types/payment";
import PageResponse from "@/types/page-response";
import { apiEndpoints } from "@/utils/api-endpoints";

const paymentApi = api.injectEndpoints({
	overrideExisting: true,
	endpoints: (builder) => ({
		getCardToCards: builder.query<PageResponse<CardToCard[]>, GetCardToCardsRequest>({
			query: (arg) => ({
				url: apiEndpoints.Payment.GetCardToCards.url,
				method: apiEndpoints.Payment.GetCardToCards.method,
				params: arg,
			}),
			providesTags: ["UsersPayment"],
		}),

		addCardToCard: builder.mutation<AddCardToCardResponse, FormData>({
			query: (formData) => ({
				url: apiEndpoints.Payment.Add.url,
				method: apiEndpoints.Payment.Add.method,
				body: formData,
			}),
			invalidatesTags: ["UsersPayment"],
		}),

		sendBankRequest: builder.mutation<string, GetPaymentTokenRequest>({
			query: (arg) => ({
				url: apiEndpoints.BankPayment.Request.url,
				method: apiEndpoints.BankPayment.Request.method,
				body: arg,
			}),
		}),
	}),
});

export const {
	useAddCardToCardMutation,
	useGetCardToCardsQuery,
	useSendBankRequestMutation,
} = paymentApi;
